import { render, staticRenderFns } from "./voucherBalanceDetail.vue?vue&type=template&id=5ec26b1c&scoped=true&"
import script from "./voucherBalanceDetail.vue?vue&type=script&lang=js&"
export * from "./voucherBalanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./voucherBalanceDetail.vue?vue&type=style&index=0&id=5ec26b1c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec26b1c",
  null
  
)

export default component.exports